import React, {Fragment, Suspense} from 'react';
import '../../Legacy/assets/legacy.css';
import LegacyFrame from "../../Legacy/LegacyFrame";

class LegacyCallLog extends React.Component {

    render() {
        return (
            <LegacyFrame withHeader={true} pageTitle={"Call History" } formname={"table_37"} customClass={"field-customization-container"} />
        );
    }
}

export default LegacyCallLog;
